<app-admin-header></app-admin-header>

<div class="content-wrapper my-5 p-t-25 dis-flex">
  <div class="main-content p-t-20">
    <div class="container-fluid" style="height: calc(100vh - 20vh)">
      <app-breadcrumb
        [items]="[{ label: 'Admin' }, { label: 'Outcomes' }]"
        [home]="{ label: 'Home', routerLink: '/home' }"
      ></app-breadcrumb>

      <div class="m-b-20 dis-flex flex-sb">
        <div>
          <h1 class="font-medium text-70 m-b-0">Outcome Templates</h1>
        </div>
        <div class="dis-flex">
          <div class="m-r-10">
            <p-dropdown
              [options]="yearList"
              optionLabel="value"
              class="dis-block"
              optionValue="value"
              [(ngModel)]="reqData.year"
              (onChange)="onFilterChange('year', reqData.year)"
              placeholder="Select Year"
            >
            </p-dropdown>
          </div>
          <button
            class="btn primary m-r-10"
            (click)="templateDownload()"
            [disabled]="isDownloading"
          >
            <ng-icon class="lh-1-0 m-r-4" name="hugeDownload03" size="18" />
            <span *ngIf="isDownloading" class="text-white">Downloading...</span>
            <span *ngIf="!isDownloading">Download</span>
          </button>

          <button class="btn black m-r-10" (click)="upload()">
            <ng-icon class="lh-1-0 m-r-4" name="hugeUpload03" size="18" />Upload
          </button>
          <button class="btn outline" (click)="sync()">
            <ng-icon class="lh-1-0 m-r-4" name="hugeReload" size="18" />Sync
          </button>
        </div>
      </div>

      <div class="content">
        <div class="table-container">
          <app-virtual-scroll
            class="w-full"
            [data]="templateListPayload"
            [apiUrl]="templateListUrl"
            (loadedData)="onDataLoaded($event)"
          >
            <ng-container *ngIf="!isLoading; else loadingData">
              <table class="scrollable-table">
                <thead>
                  <tr>
                    <th>
                      Template
                      <input
                        class="dis-block"
                        type="text"
                        [(ngModel)]="reqData.search"
                        (input)="onFilterChange('search', reqData.search)"
                        placeholder="Search..."
                      />
                    </th>
                    
                    <th>
                      Business Theme
                      <p-dropdown
                        [options]="businessThemes"
                        optionLabel="value"
                        class="dis-block"
                        optionValue="theme_id"
                        [(ngModel)]="reqData.theme_id"
                        (onChange)="onFilterChange('businessTheme', reqData.theme_id)"
                        placeholder="Select Theme"
                        [overlayOptions]="helper.getOverlayOptions()"
                      >
                      </p-dropdown>
                    </th>

                    <th>
                      Template Type
                      <p-dropdown
                        [options]="templateFilter"
                        optionLabel="label"
                        optionValue="value"
                        [(ngModel)]="reqData.type"
                        (onChange)="onFilterChange('type', reqData.type)"
                        placeholder="All Types"
                        [overlayOptions]="helper.getOverlayOptions()"
                      >
                      </p-dropdown>
                    </th>

                    <th>
                      Group
                      <p-dropdown #groupDD
                        [options]="groupFilter"
                        optionLabel="name"
                        optionValue="group_id"
                        (onFilter)="onGroupSearch($event)"
                        filter="true"
                        [(ngModel)]="reqData.group_id"
                        (onChange)="
                          onFilterChange('group_id', reqData.group_id, $event, groupDD)
                        "
                        placeholder="Select Group"
                        [overlayOptions]="helper.getOverlayOptions()"
                      >
                      </p-dropdown>
                    </th>
                    <th>
                      Designation
                      <p-dropdown #designationDD
                        [options]="designationFilter"
                        optionLabel="label"
                        optionValue="value"
                        filter="true"
                        (onFilter)="onDesignationSearch($event)"
                        [(ngModel)]="reqData.designation"
                        (onChange)="
                          onFilterChange('designation', reqData.designation, $event, designationDD)
                        "
                        placeholder="Select Designation"
                        [overlayOptions]="helper.getOverlayOptions()"
                      >
                      </p-dropdown>
                    </th>
                  </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let rowData of template">
                      <td>{{ rowData?.template | truncate : 20 }}</td>
                      <td>{{ rowData?.theme.value }}</td>
                      <td>{{ rowData?.type }}</td>
                      <td>{{ rowData?.group?.name }}</td>
                      <td>{{ rowData?.designation }}</td>
                    </tr>
                    <tr *ngIf="template.length < 1">
                      <td colspan="5"><app-no-data-found [imageWidth]="30"></app-no-data-found></td>
                    </tr>
                </tbody>
              </table>
            </ng-container>
          </app-virtual-scroll>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noData>
  <app-no-data-found></app-no-data-found>
</ng-template>
<ng-template #loadingData>
  <app-shimmer-list></app-shimmer-list>
</ng-template>
